var ExModule = (function () {
    function ExModule() {
    }
    return ExModule;
}());
export { ExModule };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/pages/exercises/ex.module.ts.pre-build-optimizer.js